import {
  apiAddOrder,
  apiDeleteOrder,
  apiGetOrders,
  apiUpdateOrder,
} from "@lib/api/billing";
import { UseQueriesProps } from "@lib/types/General";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

export const useOrderQueries = (props: UseQueriesProps) => {
  const { queryKey, params, id, messages, enabled = true } = props;
  const queryKeys = queryKey || ["order", params ? JSON.stringify(params) : id];
  const queryClient = useQueryClient();

  const ordersQuery = useQuery({
    queryFn: () => apiGetOrders(params),
    queryKey: queryKeys,
    enabled: !!params && !!enabled,
  });

  const addOrderMutation = useMutation({
    mutationFn: apiAddOrder,
    mutationKey: queryKeys,
    onSuccess() {
      toast.success(
        (messages["common.createdMessage"] as string).replace(
          "{name}",
          messages["common.order"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
    },
  });

  const updateOrderMutation = useMutation({
    mutationFn: apiUpdateOrder,
    mutationKey: queryKeys,
    onSuccess() {
      toast.success(
        (messages["common.updatedMessage"] as string).replace(
          "{name}",
          messages["common.order"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
    },
  });

  const deleteOrderMutation = useMutation({
    mutationFn: apiDeleteOrder,
    mutationKey: queryKeys,
    onSuccess() {
      toast.success(
        (messages["common.deletedMessage"] as string).replace(
          "{name}",
          messages["common.order"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
    },
  });

  return {
    ordersQuery,
    addOrderMutation,
    updateOrderMutation,
    deleteOrderMutation,
  };
};
